import { paths } from './paths'

type TrackTraceLinkParams = { barcode: string; postalCode?: string }

const trackTraceLink = ({ barcode, postalCode }: TrackTraceLinkParams): string =>
  postalCode ? `/${barcode}/${postalCode}` : `/${barcode}`

export const trackTraceLinks = {
  trackTraceOverviewLink: (params: TrackTraceLinkParams) => trackTraceLink(params),

  trackTraceDetailsLink: (params: TrackTraceLinkParams) => `${trackTraceLink(params)}/${paths.DETAILS}`,

  trackTraceSignatureLink: (params: TrackTraceLinkParams) => `${trackTraceLink(params)}/${paths.SIGNATURE}`,

  interventionsFormLink: ({ barcode, postalCode, type }: TrackTraceLinkParams & { type?: string }) =>
    `/${barcode}/${postalCode}/${paths.INTERVENTIONS}${type ? `/${type}` : ''}`,

  interventionsConfirmationLink: ({ barcode, postalCode }: TrackTraceLinkParams) =>
    `/${barcode}/${postalCode}/${paths.INTERVENTIONS}/${paths.CONFIRMATION}`,

  trackTraceLinks: () => ``,
}
